// ============================================================
// 接口定义层（与小程序后端接口约定保持一致）
//  - 调用方拿到的是 request() 归一化后的 { code, msg, data, header }
//  - 业务数据统一在 res.data 中；登录 token 在 res.header.token（真实模式）
// ============================================================
import { request } from './request'

/* ---------------- 登录（PC 扫码登录，接口待后端开发） ----------------
 * 约定：
 *  1) 创建扫码会话：POST /echo/auth/pc/qr
 *     请求：无
 *     响应 data：{ sessionId, qrImageUrl?, qrContent? }
 *       - qrImageUrl：后端直接返回的小程序码图片地址（优先）
 *       - qrContent ：微信 scheme / 链接内容，前端用 qrcode 库渲染成二维码
 *  2) 轮询会话状态：GET /echo/auth/pc/status?sessionId=xxx
 *     响应 data：{ status: 'pending' | 'scanned' | 'success' | 'expired', token?, user? }
 *       - success 时 token 为原始 token（含 Bearer 前缀），user 为用户信息
 */
export const authApi = {
  createQrCode() {
    return request({ url: '/echo/auth/pc/qr', method: 'POST' })
  },
  pollStatus(sessionId) {
    return request({ url: `/echo/auth/pc/status?sessionId=${encodeURIComponent(sessionId)}`, method: 'GET' })
  }
}

/* ---------------- 用户 ---------------- */
export const userApi = {
  info() {
    return request({ url: '/echo/user/info', method: 'GET' })
  },
  // payload: { nickname, linkInfo, avatarBase64? }
  update(payload) {
    return request({ url: '/echo/user/update', method: 'POST', data: payload })
  }
}

/* ---------------- 音色 ---------------- */
export const voiceApi = {
  /** 我的录制声音 + 场景标签 */
  all() {
    return request({ url: '/echo/voice/all', method: 'GET' })
  },
  /** 预设音色分页搜索：{ pageNum, keyword, sceneList } */
  search(payload) {
    return request({ url: '/echo/voice/search', method: 'POST', data: payload })
  }
}

/* ---------------- 配音 ---------------- */
export const dubbingApi = {
  /**
   * 创建配音任务
   * @param {Object} p
   *   - text/title/emotion/language/speed：公共参数
   *   - voiceSource: 'preset' | 'record' | 'upload'
   *   - voiceId：预设音色时必传
   *   - file / voiceName：录音或上传时必传（multipart）
   * @returns data = 配音任务 ID
   */
  start(p) {
    const common = {
      text: p.text,
      title: p.title,
      emotion: p.emotion,
      language: p.language,
      speed: p.speed
    }
    if (p.voiceSource === 'record' || p.voiceSource === 'upload') {
      const fd = new FormData()
      fd.append('file', p.file)
      fd.append('name', p.voiceName)
      Object.entries(common).forEach(([k, v]) => fd.append(k, v))
      return request({ url: '/echo/dubbing/start', method: 'POST', data: fd })
    }
    return request({
      url: '/echo/dubbing/start',
      method: 'POST',
      data: { ...common, voiceId: p.voiceId },
      formUrlEncoded: true
    })
  },
  detail(id) {
    return request({ url: `/echo/dubbing/detail?id=${id}`, method: 'GET' })
  },
  /** 历史作品分页：{ pageNum, sort, keyword?, language?, emotion? } */
  history(payload) {
    return request({ url: '/echo/dubbing/history', method: 'POST', data: payload })
  },
  remove(id) {
    return request({ url: `/echo/dubbing/${id}`, method: 'DELETE' })
  }
}
